/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M41.184 2.343L25 18.526 8.816 2.343a4.573 4.573 0 00-6.473 0 4.573 4.573 0 000 6.473L18.526 25 2.343 41.184a4.573 4.573 0 000 6.473 4.573 4.573 0 006.473 0L25 31.474l16.184 16.183a4.573 4.573 0 006.473 0 4.573 4.573 0 000-6.473L31.474 25 47.657 8.816a4.573 4.573 0 000-6.473 4.573 4.573 0 00-6.473 0z" _fill="#8C95A1" fill-rule="evenodd"/>'
  }
})
